export default __webpack_public_path__ + "78c1c7add68dca0e1827cd20c1e30973.otf";